<!-- <div class="row m-0 text-center">
    <div class="alert alert-primary text-center mv-dnone" *ngIf="browser != 'Chrome' "  style="top:0px;width: 410px !important;margin: auto !important;margin-bottom: auto;float: none;margin-left:40%;margin-bottom: -55px !important;">"For best experience, open this site on Chrome."</div>
    <button (click)="notify()">Show Notiication</button>
</div> -->
<!-- <div *ngIf="message;">
    <h1>{{ message.notification.title }}</h1>
    <h2>{{ message.notification.body }}</h2>
  
  </div>
  
  <div *ngIf="!message;">
    No Message Arrived
  </div> -->
<router-outlet></router-outlet>
